/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-procedure-speciality.reducer';

export const HospitalProcedureSpecialityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalProcedureSpecialityEntity = useAppSelector(state => state.hospitalProcedureSpeciality.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalProcedureSpecialityDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalProcedureSpeciality.detail.title">HospitalProcedureSpeciality</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalProcedureSpeciality.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalProcedureSpecialityEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalProcedureSpeciality.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalProcedureSpecialityEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalProcedureSpeciality.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalProcedureSpecialityEntity.cursor}</dd>
          <dt>
            <span id="lastUpdate">
              <Translate contentKey="tinyMedicRestApp.hospitalProcedureSpeciality.lastUpdate">Last Update</Translate>
            </span>
          </dt>
          <dd>{hospitalProcedureSpecialityEntity.lastUpdate}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalProcedureSpeciality.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{hospitalProcedureSpecialityEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.hospitalProcedureSpeciality.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{hospitalProcedureSpecialityEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalProcedureSpeciality.speciality">Speciality</Translate>
          </dt>
          <dd>{hospitalProcedureSpecialityEntity.speciality ? hospitalProcedureSpecialityEntity.speciality.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalProcedureSpeciality.procedure">Procedure</Translate>
          </dt>
          <dd>{hospitalProcedureSpecialityEntity.procedure ? hospitalProcedureSpecialityEntity.procedure.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalProcedureSpeciality.hospitalProcedure">Hospital Procedure</Translate>
          </dt>
          <dd>{hospitalProcedureSpecialityEntity.hospitalProcedure ? hospitalProcedureSpecialityEntity.hospitalProcedure.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital-procedure-speciality" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital-procedure-speciality/${hospitalProcedureSpecialityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalProcedureSpecialityDetail;
